exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._31PpZ{padding:10px 0}._1MvqR{text-align:center;font-size:24px;font-weight:300;padding:50px 10px 90px}", ""]);

// exports
exports.locals = {
	"root": "_31PpZ",
	"emptyMessage": "_1MvqR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/advert/components/TestDrives/TestDrives.css
// module id = 3305
// module chunks = 32